import styled from 'styled-components/macro';
import px2vw from '../../../utils/px2vw';


export const QberaaTopSection = styled.div`

`;

export const QberaaTextContents = styled.div`
    display: flex;
    flex-direction : row;
    padding-top :${px2vw(261)};
    padding-left : ${px2vw(200)};
    padding-bottom : ${px2vw(59)};    
`;

export const BackGroundVideo = styled.video`
    width: 100%;
    z-index: -1;
    clip-path: polygon(0 0, 100% 0%, 100% 60%, 0 82%, 0% 50%);
    position: absolute;
    top:  ${px2vw(-65)};
    @media only screen and (max-width: 425px) {
        top: 7%;
    }
`;

export const QberaaMainTitle = styled.p`
    font-family: ${props => props.theme.secfontFamily};
    font-size: ${px2vw(56)};
    font-weight: 700;
    line-height:  ${px2vw(60)};
    letter-spacing: ${props => props.theme.subtitleLetterSpacing};
    color: #FFFFFF;
    margin-top: 0px;
    margin-bottom: ${px2vw(14)};
    @media only screen and (max-width: 425px) {
        display : none;
    }
`;

export const QberaaMainsubTitle = styled.p`
    margin-top: ${px2vw(-75)};    
    font-family: ${props => props.theme.fontFamily};
    font-size:  ${props => { 
        return props.theme.mobCommonTitleFontSize?props.theme.mobCommonTitleFontSize:px2vw(16)
    }};  
    letter-spacing: ${props => props.theme.subtitleLetterSpacing};
    font-weight: 700;
    line-height:  ${px2vw(24)};
    @media only screen and (max-width: 425px) {
        margin-top:0px;
    }

`;

export const QmainCol = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom:  ${px2vw(44)};
    padding-top:  ${px2vw(261)};
    padding-left:  ${props => props.theme.paddingLeft};    
    @media only screen and (max-width: 425px) {
        padding-top:  ${px2vw(360)};
        padding-left: 5%;
        padding-right: 5%;
    }
`;

export const QberaaMaintext = styled.p`
    font-family: ${props => props.theme.fontFamily};    
    font-size:  ${props => props.theme.pFontSize};
    line-height:  ${props => props.theme.pLineHeight};
    margin-top: ${px2vw(-40)};
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0px;
    width: ${px2vw(505)};
    height: ${px2vw(196)};
    @media only screen and (max-width: 425px) {
        width: 90%;
        height : auto;
        margin-top : 4%;
    }
`;

export const QberaaMainRedBox = styled.div`
    height: ${px2vw(12)};
    width: ${px2vw(81)};
    border-radius: 0px;
    background: #E32C5E;
    @media only screen and (max-width: 425px) {
        display : none;
    }
`;

export const QmainRow = styled.div`
    display: flex;
    flex-direction: row;    
    @media only screen and (max-width: 425px) {
        justify-content: center;
        padding-bottom: 7%;
    }

`;


export const QberaaAppImg = styled.img`
    width: ${px2vw(848)};
    height: ${px2vw(456)};
    @media only screen and (max-width: 425px) {
        width: 100%;
        height: auto;
        padding-bottom: 20%;
    }
`;